export const filterLabelSx = {
    fontSize: '0.625rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: 'text.secondary',
}

export const filterCheckboxSx = {
    p: 0,
    mr: 0.5,
    mt: '-2px',
    '& .MuiSvgIcon-root': {
        fontSize: '0.875rem',
    },
}

export const filterCheckboxLabelSx = {
    m: 0,
    '& .MuiFormControlLabel-label': {
        fontSize: '0.5625rem',
        color: 'text.secondary',
    },
}
